export const legalSections: ReadonlyArray<[title: string, body: string]> = [
  [
    "Informação",
    "Os relatórios têm carácter informativo e organizam sinais públicos. Não substituem consulta jurídica, financeira ou técnica.",
  ],
  [
    "Fontes",
    "Cada categoria indica fonte, data de consulta, estado operacional e evidência disponível. Falhas técnicas, fontes não ligadas e ausência de correspondência são tratados como estados diferentes.",
  ],
  [
    "Limites",
    "Ausência numa lista pública não equivale a certidão oficial de não dívida, inexistência de processos ou validação jurídica atualizada.",
  ],
  [
    "Dados pessoais",
    "O produto deve minimizar dados pessoais, guardar apenas o necessário para acesso ao relatório e respeitar pedidos de correção.",
  ],
];
